/**
 * STICKY ADD TO CART PERFECT
 * Version 2.0 - Performance & UX Optimized
 * Compatible avec tous les thèmes Shopify
 */

class StickyAddToCart {
  constructor() {
    this.isVisible = false;
    this.isAnimating = false;
    this.productForm = null;
    this.stickyElement = null;
    this.originalButton = null;
    this.breakpoint = 768; // Mobile breakpoint
    this.scrollThreshold = 300; // Pixels à scroller avant d'afficher
    this.animationDuration = 300; // ms
    
    this.init();
  }

  init() {
    // Attendre que le DOM soit prêt
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Trouver le formulaire produit principal
    this.productForm = document.querySelector('product-form[data-main="true"]') || 
                      document.querySelector('form[action*="/cart/add"]');
    
    if (!this.productForm) {
      console.warn('StickyAddToCart: Aucun formulaire produit trouvé');
      return;
    }

    // Trouver le bouton add to cart original
    this.originalButton = this.productForm.querySelector('[name="add"]') ||
                         this.productForm.querySelector('.product-form__submit') ||
                         this.productForm.querySelector('button[type="submit"]');

    if (!this.originalButton) {
      console.warn('StickyAddToCart: Aucun bouton add to cart trouvé');
      return;
    }

    this.createStickyElement();
    this.bindEvents();
    this.hide(); // Cacher par défaut au chargement
    this.setupIntersectionObserver();
  }

  createStickyElement() {
    // Créer l'élément sticky
    this.stickyElement = document.createElement('div');
    this.stickyElement.className = 'sticky-add-to-cart';
    this.stickyElement.innerHTML = `
      <div class="sticky-atc-container">
        <div class="sticky-atc-content">
          <div class="sticky-atc-product-info">
            <div class="sticky-atc-image"></div>
            <div class="sticky-atc-details">
              <h3 class="sticky-atc-title"></h3>
              <div class="sticky-atc-price"></div>
            </div>
          </div>
          <div class="sticky-atc-actions">
            <div class="sticky-atc-quantity">
              <button type="button" class="sticky-atc-qty-btn minus" aria-label="Diminuer la quantité">−</button>
              <input type="number" class="sticky-atc-qty-input" value="1" min="1" max="99" aria-label="Quantité">
              <button type="button" class="sticky-atc-qty-btn plus" aria-label="Augmenter la quantité">+</button>
            </div>
            <button type="button" class="sticky-atc-add-btn" disabled>
              <span class="sticky-atc-btn-text">AJOUTER AU PANIER</span>
              <div class="sticky-atc-loading hidden">
                <svg class="spinner" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                    <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
                    <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
                  </circle>
                </svg>
              </div>
            </button>
          </div>
        </div>
        <button type="button" class="sticky-atc-close" aria-label="Fermer">×</button>
      </div>
    `;

    // Ajouter les styles CSS
    this.addStyles();
    
    // Ajouter au DOM
    document.body.appendChild(this.stickyElement);

    // Remplir les informations produit
    this.populateProductInfo();
  }

  addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .sticky-add-to-cart {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background: #ffffff;
        border-top: 1px solid #e8e8e8;
        box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);
        transform: translateY(100%);
        transition: transform ${this.animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1);
        will-change: transform;
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        max-height: 80px;
        overflow: hidden;
      }

      .sticky-add-to-cart.visible {
        transform: translateY(0);
      }

      .sticky-atc-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        max-width: 1200px;
        margin: 0 auto;
        gap: 12px;
        position: relative;
        max-height: 80px;
        box-sizing: border-box;
      }

      .sticky-atc-content {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: 1;
      }

      .sticky-atc-product-info {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
        flex: 1;
      }

      .sticky-atc-image {
        width: 50px;
        height: 50px;
        border-radius: 8px;
        background: #f5f5f5;
        flex-shrink: 0;
        overflow: hidden;
      }

      .sticky-atc-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .sticky-atc-details {
        min-width: 0;
        flex: 1;
      }

      .sticky-atc-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin: 0 0 4px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .sticky-atc-price {
        font-size: 16px;
        font-weight: 700;
        color: #e4bc77;
      }

      .sticky-atc-actions {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .sticky-atc-quantity {
        display: flex;
        align-items: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        overflow: hidden;
      }

      .sticky-atc-qty-btn {
        width: 32px;
        height: 32px;
        border: none;
        background: #f8f8f8;
        color: #333;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.2s;
      }

      .sticky-atc-qty-btn:hover {
        background: #e8e8e8;
      }

      .sticky-atc-qty-input {
        width: 50px;
        height: 32px;
        border: none;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        background: #fff;
        outline: none;
      }

      .sticky-atc-add-btn {
        background: linear-gradient(135deg, #e4bc77 0%, #d4a867 100%);
        color: #fff;
        border: none;
        border-radius: 12px;
        padding: 16px 32px;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        min-width: 160px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 15px rgba(228, 188, 119, 0.3);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .sticky-atc-add-btn:hover:not(:disabled) {
        background: linear-gradient(135deg, #d4a867 0%, #c49857 100%);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(228, 188, 119, 0.4);
      }

      .sticky-atc-add-btn:disabled {
        background: #e0e0e0;
        color: #999;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
        opacity: 0.6;
      }

      .sticky-atc-add-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s;
      }

      .sticky-atc-add-btn:hover:not(:disabled)::before {
        left: 100%;
      }

      .sticky-atc-loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .sticky-atc-loading.hidden {
        display: none;
      }

      .spinner {
        width: 20px;
        height: 20px;
      }

      .sticky-atc-close {
        width: 32px;
        height: 32px;
        border: none;
        background: none;
        font-size: 20px;
        color: #666;
        cursor: pointer;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.2s;
        flex-shrink: 0;
      }

      .sticky-atc-close:hover {
        background: #f0f0f0;
      }

      /* Mobile optimizations */
      @media (max-width: 768px) {
        .sticky-add-to-cart {
          max-height: 70px;
        }
        
        .sticky-atc-container {
          padding: 8px 12px;
          gap: 8px;
          max-height: 70px;
        }

        .sticky-atc-content {
          gap: 8px;
        }

        .sticky-atc-product-info {
          gap: 8px;
        }

        .sticky-atc-image {
          width: 35px;
          height: 35px;
        }

        .sticky-atc-title {
          font-size: 12px;
        }

        .sticky-atc-price {
          font-size: 13px;
        }

        .sticky-atc-add-btn {
          padding: 8px 12px;
          font-size: 12px;
          min-width: 100px;
          height: 35px;
        }

        .sticky-atc-actions {
          gap: 6px;
        }

        .sticky-atc-qty-btn {
          width: 25px;
          height: 25px;
          font-size: 12px;
        }

        .sticky-atc-qty-input {
          width: 35px;
          height: 25px;
          font-size: 12px;
        }
      }

      /* Animation d'entrée */
      @keyframes slideUp {
        from {
          transform: translateY(100%);
        }
        to {
          transform: translateY(0);
        }
      }

      .sticky-add-to-cart.visible {
        animation: slideUp ${this.animationDuration}ms cubic-bezier(0.4, 0, 0.2, 1);
      }
    `;
    
    document.head.appendChild(style);
  }

  populateProductInfo() {
    // Mode produit normal (bundle renderer désactivé temporairement)

    // Mode produit normal
    const productTitle = document.querySelector('.product__title, .product-title, h1')?.textContent?.trim();
    const productPrice = document.querySelector('.price .price__regular, .price-item--regular, .product-price')?.textContent?.trim();
    const productImage = document.querySelector('.product__media img, .product-image img, .product__photo img')?.src;

    // Remplir les éléments
    const titleEl = this.stickyElement.querySelector('.sticky-atc-title');
    const priceEl = this.stickyElement.querySelector('.sticky-atc-price');
    const imageEl = this.stickyElement.querySelector('.sticky-atc-image');

    if (titleEl && productTitle) {
      titleEl.textContent = productTitle;
    }

    if (priceEl && productPrice) {
      priceEl.textContent = productPrice;
    }

    if (imageEl && productImage) {
      imageEl.innerHTML = `<img src="${productImage}" alt="${productTitle}" loading="lazy">`;
    }
  }

  bindEvents() {
    // Bouton d'ajout au panier
    const addBtn = this.stickyElement.querySelector('.sticky-atc-add-btn');
    addBtn.addEventListener('click', () => this.handleAddToCart());

    // Boutons de quantité
    const minusBtn = this.stickyElement.querySelector('.sticky-atc-qty-btn.minus');
    const plusBtn = this.stickyElement.querySelector('.sticky-atc-qty-btn.plus');
    const qtyInput = this.stickyElement.querySelector('.sticky-atc-qty-input');

    minusBtn.addEventListener('click', () => this.decreaseQuantity());
    plusBtn.addEventListener('click', () => this.increaseQuantity());
    qtyInput.addEventListener('change', () => this.validateQuantity());

    // Bouton de fermeture
    const closeBtn = this.stickyElement.querySelector('.sticky-atc-close');
    closeBtn.addEventListener('click', () => this.hide());

    // Synchroniser avec le formulaire original
    this.syncWithOriginalForm();
    
    // Écouter les changements de variantes
    this.setupVariantListeners();
  }

  syncWithOriginalForm() {
    // Synchroniser la quantité
    const originalQtyInput = this.productForm.querySelector('input[name="quantity"]');
    if (originalQtyInput) {
      const stickyQtyInput = this.stickyElement.querySelector('.sticky-atc-qty-input');
      stickyQtyInput.value = originalQtyInput.value || 1;
    }

    // Synchroniser les variantes
    const variantSelects = this.productForm.querySelectorAll('select[name*="id"], input[name="id"]');
    if (variantSelects.length > 0) {
      this.updateVariantInfo();
    }

    // Vérifier si une variante est sélectionnée
    this.checkVariantSelection();
  }

  updateVariantInfo() {
    // Mettre à jour le prix et la disponibilité selon la variante sélectionnée
    const variantId = this.getSelectedVariantId();
    if (variantId) {
      // Ici vous pouvez ajouter la logique pour récupérer les infos de variante
      // et mettre à jour le prix dans le sticky element
    }
  }

  getSelectedVariantId() {
    const variantInput = this.productForm.querySelector('input[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  checkVariantSelection() {
    const addBtn = this.stickyElement.querySelector('.sticky-atc-add-btn');
    const variantId = this.getSelectedVariantId();
    
    // Vérifier si une variante est sélectionnée
    if (variantId && variantId !== '') {
      addBtn.disabled = false;
      addBtn.style.opacity = '1';
    } else {
      addBtn.disabled = true;
      addBtn.style.opacity = '0.6';
    }
  }

  setupVariantListeners() {
    // Écouter les changements sur les sélecteurs de variantes
    const variantSelects = this.productForm.querySelectorAll('select[name*="id"], input[name="id"]');
    variantSelects.forEach(select => {
      select.addEventListener('change', () => {
        setTimeout(() => this.checkVariantSelection(), 100);
      });
    });

    // Écouter les changements sur les boutons de variantes (couleur, taille, etc.)
    const variantButtons = this.productForm.querySelectorAll('input[type="radio"][name*="option"], button[data-option]');
    variantButtons.forEach(button => {
      button.addEventListener('change', () => {
        setTimeout(() => this.checkVariantSelection(), 100);
      });
      button.addEventListener('click', () => {
        setTimeout(() => this.checkVariantSelection(), 100);
      });
    });

    // Écouter les changements sur les inputs de variantes
    const variantInputs = this.productForm.querySelectorAll('input[name="id"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        setTimeout(() => this.checkVariantSelection(), 100);
      });
    });

    // Observer les changements dans le DOM pour les variantes dynamiques
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          setTimeout(() => this.checkVariantSelection(), 100);
        }
      });
    });

    // Observer le formulaire pour les changements de variantes
    observer.observe(this.productForm, {
      attributes: true,
      subtree: true,
      attributeFilter: ['value', 'data-variant-id']
    });
    
    // Écouter les événements du cart drawer
    this.setupCartDrawerListeners();
  }

  setupCartDrawerListeners() {
    // Écouter les événements de mise à jour du panier
    document.addEventListener('cart:updated', () => {
      console.log('Cart updated event reçu');
      setTimeout(() => this.updateCartDrawer(), 100);
    });
    
    document.addEventListener('cart:refresh', () => {
      console.log('Cart refresh event reçu');
      setTimeout(() => this.updateCartDrawer(), 100);
    });
    
    // Écouter les événements d'ouverture du cart drawer
    document.addEventListener('cart:open', () => {
      console.log('Cart open event reçu');
    });
    
    // Observer les changements dans le DOM pour détecter l'ouverture du cart drawer
    const cartObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'aria-hidden')) {
          const target = mutation.target;
          if (target.matches('cart-drawer, .cart-drawer, .drawer')) {
            const isOpen = target.classList.contains('active') || 
                          target.classList.contains('open') || 
                          target.getAttribute('aria-hidden') === 'false';
            console.log('Cart drawer état changé:', isOpen ? 'ouvert' : 'fermé');
          }
        }
      });
    });
    
    // Observer tous les cart drawers
    const cartDrawers = document.querySelectorAll('cart-drawer, .cart-drawer, .drawer');
    cartDrawers.forEach(drawer => {
      cartObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    });
  }

  increaseQuantity() {
    const qtyInput = this.stickyElement.querySelector('.sticky-atc-qty-input');
    const currentQty = parseInt(qtyInput.value) || 1;
    const maxQty = parseInt(qtyInput.max) || 99;
    
    if (currentQty < maxQty) {
      qtyInput.value = currentQty + 1;
      this.syncQuantityToOriginal();
    }
  }

  decreaseQuantity() {
    const qtyInput = this.stickyElement.querySelector('.sticky-atc-qty-input');
    const currentQty = parseInt(qtyInput.value) || 1;
    const minQty = parseInt(qtyInput.min) || 1;
    
    if (currentQty > minQty) {
      qtyInput.value = currentQty - 1;
      this.syncQuantityToOriginal();
    }
  }

  validateQuantity() {
    const qtyInput = this.stickyElement.querySelector('.sticky-atc-qty-input');
    const value = parseInt(qtyInput.value) || 1;
    const minQty = parseInt(qtyInput.min) || 1;
    const maxQty = parseInt(qtyInput.max) || 99;
    
    qtyInput.value = Math.max(minQty, Math.min(maxQty, value));
    this.syncQuantityToOriginal();
  }

  syncQuantityToOriginal() {
    const stickyQty = this.stickyElement.querySelector('.sticky-atc-qty-input').value;
    const originalQtyInput = this.productForm.querySelector('input[name="quantity"]');
    
    if (originalQtyInput) {
      originalQtyInput.value = stickyQty;
    }
  }

  setupIntersectionObserver() {
    // Trouver la section bundle pour détecter quand on la dépasse
    const bundleSection = document.querySelector('[id*="product-bundle-section"], .cpb-section-wrapper, .bundle-section');
    
    if (bundleSection) {
      // Observer la section bundle au lieu du formulaire produit
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Si la section bundle est visible, cacher le sticky
            this.hide();
          } else {
            // Si la section bundle n'est plus visible, vérifier si on a scrollé assez
            const scrollY = window.scrollY;
            const bundleBottom = bundleSection.offsetTop + bundleSection.offsetHeight;
            
            // Afficher le sticky seulement si on a dépassé la section bundle
            if (scrollY > bundleBottom) {
              this.show();
            } else {
              this.hide();
            }
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px'
      });

      observer.observe(bundleSection);
      
      // Ajouter un listener de scroll pour une détection plus précise
      let scrollTimeout;
      window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollY = window.scrollY;
          const bundleBottom = bundleSection.offsetTop + bundleSection.offsetHeight;
          
          // Afficher le sticky seulement si on a dépassé la section bundle
          if (scrollY > bundleBottom) {
            this.show();
          } else {
            this.hide();
          }
        }, 10); // Délai pour éviter trop d'appels
      });
    } else {
      // Fallback : observer le formulaire original si pas de bundle trouvé
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.hide();
          } else {
            this.show();
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      if (this.productForm) {
        observer.observe(this.productForm);
      }
    }
  }

  show() {
    if (this.isVisible || this.isAnimating) return;
    
    this.isAnimating = true;
    this.stickyElement.classList.add('visible');
    
    setTimeout(() => {
      this.isVisible = true;
      this.isAnimating = false;
    }, this.animationDuration);
  }

  hide() {
    if (!this.isVisible || this.isAnimating) return;
    
    this.isAnimating = true;
    this.stickyElement.classList.remove('visible');
    
    setTimeout(() => {
      this.isVisible = false;
      this.isAnimating = false;
    }, this.animationDuration);
  }

  async handleAddToCart() {
    const addBtn = this.stickyElement.querySelector('.sticky-atc-add-btn');
    const btnText = this.stickyElement.querySelector('.sticky-atc-btn-text');
    const loading = this.stickyElement.querySelector('.sticky-atc-loading');
    
    // État de chargement
    addBtn.disabled = true;
    btnText.classList.add('hidden');
    loading.classList.remove('hidden');

    try {
      // Mode produit normal (bundle renderer désactivé temporairement)
      const formData = new FormData(this.productForm);
      
      // Mettre à jour la quantité
      const qty = this.stickyElement.querySelector('.sticky-atc-qty-input').value;
      formData.set('quantity', qty);

      // Ajouter les paramètres pour le cart drawer
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout au panier');
      }

      const data = await response.json();
      console.log('Produit ajouté au panier:', data);
      
      // Mettre à jour le cart drawer
      await this.updateCartDrawer();
      
      // Attendre un peu pour que le cart drawer soit mis à jour
      setTimeout(() => {
        // Ouvrir le cart drawer
        this.openCartDrawer();
        
        // Fermer le sticky après un délai
        setTimeout(() => {
          this.hide();
        }, 1000);
      }, 200);

    } catch (error) {
      console.error('Erreur:', error);
      this.showErrorNotification(error.message);
    } finally {
      // Réinitialiser l'état du bouton
      addBtn.disabled = false;
      btnText.classList.remove('hidden');
      loading.classList.add('hidden');
    }
  }

  async updateCartDrawer() {
    try {
      console.log('Mise à jour du cart drawer...');
      const response = await fetch('/?sections=cart-drawer&sections_url=' + encodeURIComponent(window.location.pathname));
      const sections = await response.json();
      
      if (sections['cart-drawer']) {
        // Chercher le cart drawer avec différents sélecteurs
        const cartDrawerSelectors = [
          'cart-drawer',
          '.cart-drawer',
          '.drawer',
          '[class*="cart-drawer"]'
        ];
        
        let cartDrawer = null;
        for (const selector of cartDrawerSelectors) {
          cartDrawer = document.querySelector(selector);
          if (cartDrawer) break;
        }
        
        if (cartDrawer) {
          console.log('Cart drawer trouvé pour mise à jour:', cartDrawer);
          const parser = new DOMParser();
          const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          const newCartDrawer = doc.querySelector('cart-drawer') || doc.querySelector('.cart-drawer') || doc.querySelector('.drawer');
          
          if (newCartDrawer) {
            // Préserver l'état actif
            const wasActive = cartDrawer.classList.contains('active') || cartDrawer.classList.contains('open');
            cartDrawer.innerHTML = newCartDrawer.innerHTML;
            
            if (wasActive) {
              cartDrawer.classList.add('active', 'open');
              document.body.classList.add('cart-drawer-open');
            }
            
            console.log('Cart drawer mis à jour avec succès');
          }
        } else {
          console.warn('Aucun cart drawer trouvé pour la mise à jour');
        }
      }
    } catch (error) {
      console.error('Erreur mise à jour cart drawer:', error);
    }
  }

  showSuccessNotification() {
    // Créer notification de succès
    const notification = document.createElement('div');
    notification.className = 'sticky-atc-notification success';
    notification.innerHTML = `
      <div class="notification-content">
        <svg class="notification-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <span>Produit ajouté au panier !</span>
      </div>
    `;

    // Styles pour la notification
    const style = document.createElement('style');
    style.textContent = `
      .sticky-atc-notification {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 1001;
        background: #4CAF50;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transform: translateX(100%);
        transition: transform 0.3s ease;
      }

      .sticky-atc-notification.show {
        transform: translateX(0);
      }

      .notification-content {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .notification-icon {
        width: 20px;
        height: 20px;
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(notification);

    // Afficher la notification
    setTimeout(() => notification.classList.add('show'), 100);

    // Supprimer après 3 secondes
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(notification);
        document.head.removeChild(style);
      }, 300);
    }, 3000);
  }

  showErrorNotification(message) {
    // Créer notification d'erreur
    const notification = document.createElement('div');
    notification.className = 'sticky-atc-notification error';
    notification.innerHTML = `
      <div class="notification-content">
        <svg class="notification-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
        <span>${message}</span>
      </div>
    `;

    // Styles pour la notification d'erreur
    const style = document.createElement('style');
    style.textContent = `
      .sticky-atc-notification.error {
        background: #f44336;
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(notification);

    // Afficher la notification
    setTimeout(() => notification.classList.add('show'), 100);

    // Supprimer après 5 secondes
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        document.body.removeChild(notification);
        document.head.removeChild(style);
      }, 300);
    }, 5000);
  }

  openCartDrawer() {
    // Essayer plusieurs méthodes pour ouvrir le cart drawer
    
    // Méthode 1: Chercher le cart drawer avec différents sélecteurs
    const cartDrawerSelectors = [
      'cart-drawer',
      '.cart-drawer',
      '.drawer',
      '[class*="cart-drawer"]',
      '.cart-drawer-wrapper',
      '.drawer__inner',
      '.cart-drawer__inner'
    ];
    
    let cartDrawer = null;
    for (const selector of cartDrawerSelectors) {
      cartDrawer = document.querySelector(selector);
      if (cartDrawer) break;
    }
    
    if (cartDrawer) {
      console.log('Cart drawer trouvé:', cartDrawer);
      
      // Essayer différentes méthodes d'ouverture
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else if (typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      } else {
        // Méthodes CSS
        cartDrawer.classList.add('active', 'open', 'is-open', 'drawer--open');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open', 'drawer-open', 'overflow-hidden');
      }
    }
    
    // Méthode 2: Chercher le bouton panier et le cliquer
    const cartButtonSelectors = [
      '.cart-count-bubble',
      '.cart-link',
      '[class*="cart"]',
      '.header__icon--cart',
      '.cart-icon',
      'button[aria-label*="cart"]',
      'a[href*="cart"]'
    ];
    
    let cartButton = null;
    for (const selector of cartButtonSelectors) {
      cartButton = document.querySelector(selector);
      if (cartButton) break;
    }
    
    if (cartButton) {
      console.log('Bouton panier trouvé:', cartButton);
      cartButton.click();
    }
    
    // Méthode 3: Déclencher les événements Shopify
    const events = [
      'cart:open',
      'cart:show',
      'drawer:open',
      'cart-drawer:open'
    ];
    
    events.forEach(eventName => {
      const event = new CustomEvent(eventName, {
        bubbles: true,
        detail: { source: 'sticky-add-to-cart' }
      });
      document.dispatchEvent(event);
    });
    
    // Méthode 4: Utiliser l'API Shopify si disponible
    if (typeof Shopify !== 'undefined' && Shopify.theme) {
      // Déclencher l'ouverture via l'API Shopify
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }
    }
    
    // Méthode 5: Forcer l'ouverture avec un délai
    setTimeout(() => {
      const allCartDrawers = document.querySelectorAll('cart-drawer, .cart-drawer, .drawer');
      allCartDrawers.forEach(drawer => {
        if (!drawer.classList.contains('active') && !drawer.classList.contains('open')) {
          drawer.classList.add('active', 'open');
          document.body.classList.add('cart-drawer-open');
        }
      });
    }, 100);
    
    // Méthode 6: Dernier recours - simuler un clic sur le bouton panier
    setTimeout(() => {
      const cartButtons = document.querySelectorAll('button[aria-label*="cart"], a[href*="cart"], .cart-count-bubble, .cart-link');
      if (cartButtons.length > 0) {
        console.log('Tentative d\'ouverture via clic sur bouton panier');
        cartButtons[0].click();
      }
    }, 300);
  }
}

// Initialiser le sticky add to cart

